import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import { setUserPhoneNumber, fetchReferralCode } from "./actions";
import { sendReferralMessage } from "../../desktop/refer-friend/actions";
import Refer from "./component";

const mapStateToProps = ({
    refer: {
        userPhoneNumber,
        isFetchingDetails,
        details: {
            referral_url: referralUrl,
            referral_id: referralId
        },
        error
    },
    user: {
        isLoggedIn,
        mobile
    }
}) => ({
    userPhoneNumber,
    isFetchingDetails,
    referralUrl,
    referralId,
    isLoggedIn,
    mobile,
    error
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setUserPhoneNumberConnect: setUserPhoneNumber,
    fetchReferralCodeConnect: fetchReferralCode,
    sendReferralMessageConnect: sendReferralMessage
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Refer));
